const CookieHelper = require('../../../../dog-racing/js/helpers/cookie-helper').default;
var slip = require('./slip.js');
var translation = window['langArr'][window['language']];   
var ticket;
var tickets;

module.exports = {
    buyTicket : function(credit,user){
        authenticate(credit,user);
    },
    getTickets : function(){
        /**
         * Session ID IE TOKEN FOR API.
         */
        let sessionToken = window['customLoggedIn'] && window['customToken'] ?
        window['customToken'] : CookieHelper.get('token') != '' ?
            CookieHelper.get('token') : window['token'];
        var tmp = null;
        $.ajax({
        url: window['API_URL'] + '/vfootball-league/ticket/get',
        type: "post",
           data: {SessionID: sessionToken} ,
           success: function (response) {
               tmp = response;
                $('#ticketsScroll').html('');
                $.each( response, function( key, value ) {
                    $('#ticketsScroll').append(ticketHtml(key, value));
                });
                tickets = response;

           },
           error: function(jqXHR, textStatus, errorThrown) {
                   console.log(jqXHR.responseText)     
           }
       });

    return tmp;
    },
    updateTicket : function (data) {
        var result = [];
        $.each( data['LeagueMatches'], function( key, value ) {
        var homeGoals = 0;
        var awayGoals = 0;
        if (!value.video1 || !value.video2 || !value.video3 || !value.video4 || !value.video5 || !value.video6) {
            homeGoals = '-';
            awayGoals = '-';
            var gameFlow = [
                ' - : - ',
                ' - : - ',
                ' - : - ',
                ' - : - ',
                ' - : - ',
                ' - : - '
            ];
        } else {
            video1Result = value.video1.split('_')[1];
            video2Result = value.video2.split('_')[1];
            video3Result = value.video3.split('_')[1];
            video4Result = value.video4.split('_')[1];
            video5Result = value.video5.split('_')[1];
            video6Result = value.video6.split('_')[1];
    
            homeGoals = parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0)) + parseInt(video6Result.charAt(0));
            awayGoals = parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1)) + parseInt(video6Result.charAt(1));
            homeHtGoals = parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0));
            awayHtGoals = parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1));
    
            var gameFlow = [
                parseInt(video1Result.charAt(0)) +':'+parseInt(video1Result.charAt(1)),
                (parseInt(video1Result.charAt(0)) +  parseInt(video2Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1))),
                (parseInt(video1Result.charAt(0)) +  parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)))  +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1))),
                (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1))),
                (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1))),
                (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0)) + parseInt(video6Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1)) + parseInt(video6Result.charAt(1))),
            ];
        }

         result[value.ID] = {
            homeGoals : homeGoals,
            awayGoals : awayGoals,
            homeHtGoals : homeHtGoals,
            awayHtGoals : awayHtGoals,
            gameFlow : gameFlow,
            halftime : gameFlow[2]
        }; 
    });
      checkTicket(tickets, result)
    }
};

/**
 * User Authetication.
 */
const authenticate = async (credit, user) => {
    if(!window['token']) {
        // if loginpopup=0 in url
            if (/loginpopup=0/.test(window['location']['href'])) {
                if (window['customLoggedIn'] && window['customToken']) {
                    buyTicketAdapter();
                } else {
                    // If no login token set, send login required msg to parent iframe
                    window.parent.postMessage(JSON.stringify({
                    source:"elbet-messages",
                    payload:{action:"loginRequired"}
                    }),'*');
                    try {
                    await getTokenPromise();
                    } catch (error) {
                        // Game specific logic for clearing bets
                        slip.emptySlip();
                    return;
                    }
                    buyTicketAdapter(credit, user);
                }
            } else {
                $('#modalErrorMessage').text(translation['please_login']);
                $('#buyTicketError').modal('show')
            return;
            }
        } else {
        // If there is a url token ie window['token']
        if (/loginpopup=0/.test(window['location']['href'])) {
            // if customLogged in true and no customToken then request login 
            // (which means that login was initiated before but token has been removed)
            if (window['customLoggedIn'] && !window['customToken']) {
                window.parent.postMessage(JSON.stringify({
                source:"elbet-messages",
                payload:{action:"loginRequired"}
            }),'*');
            try {
                await getTokenPromise();
            } catch (error) {
                // Game specific logic for clearing bets
                slip.emptySlip();
                return;
            }
            buyTicketAdapter(credit, user);
            } else {
            buyTicketAdapter(credit, user);
            } 
        } else {
            buyTicketAdapter(credit, user);
        }
    }
}

/**
* Window token promise.
*/
const getTokenPromise = () => {
    let tokenPromise = new Promise((resolve, reject) => {
        window.addEventListener("message", (event) => {
        try {
            if (JSON.parse(event.data).payload.action == 'login') {
            window['customLoggedIn'] = true;
            if (!JSON.parse(event.data).payload.token) {
                reject(new Error('Empty Token Recieved'))
            }
            window['customToken'] = JSON.parse(event.data).payload.token;
            resolve(window['customToken']);
            } 
        } catch (error) {
            reject(error);
        }
    }, false);
        window['customToken'] ? resolve(window['customToken']) : '';
    });

    return tokenPromise;
}

/**
 * Buy ticket Logics.
 */
const buyTicketAdapter = (credit,user) => {

    if(Object.keys(slip.getSlip()).length < 1){
        $('#modalErrorMessage').text(translation['chose_some_bets']);
        $('#buyTicketError').modal('show');
        return false;
    }

    var newTicket = ticketToString();
    var betData = slip.getBettingData();
    var bettingAmount = parseFloat($('#slip-btn').val());
    /**
     * Session ID IE TOKEN FOR API.
     */
    let sessionToken = window['customLoggedIn'] && window['customToken'] ?
         window['customToken'] : CookieHelper.get('token') != '' ?
             CookieHelper.get('token') : window['token'];

    var ticketJson = {
        'NewLeagueTicket': {
            'SessionID': sessionToken,
            'TicketAmount': betData.ticketAmount,
            'System': betData.system,
            'Items': newTicket
        } 
    };

    if (parseFloat(bettingAmount) < parseFloat($('#min-bet').data('value'))) {
        $('#modalErrorMessage').text(translation['minimum_stake_is'] + " " + $('#min-bet').data('value'));
        $('#buyTicketError').modal('show');
        return false;
    }

    if (parseFloat(bettingAmount) > parseFloat($('#max-bet').data('value'))) {
        $('#modalErrorMessage').text(translation['maximum_stake_is'] + " " + $('#max-bet').data('value'));
        $('#buyTicketError').modal('show');
        return false;
    }

    if (CookieHelper.get('uName') !== undefined && CookieHelper.get('uName') != '' && CookieHelper.get('uName') != null) {
        credit.getAsyncCredit(user).then(function(deposit)  {
            
            if (parseFloat(bettingAmount) > parseFloat(deposit)) {
                $('#modalErrorMessage').text(translation['you_dont_have_enough_deposit']);
                $('#buyTicketError').modal('show');
                return false;
            }
            $.ajax({
                url: window['API_URL'] + '/vfootball-league/ticket/buy',
                type: "post",
                data: ticketJson , 
                success: function (response) {
                    if(response.Status == 0){
                        $('#modalErrorMessage').text(translation['error_purchasing_ticket']);
                        $('#buyTicketError').modal('show')
                        return false;
                    } else {
                        $('#modalErrorMessage').text(translation['purchased_a_ticket']);
                        $('#buyTicketError').modal('show');
                        if ("TicketData" in response) {
                            if ("LeagueTicketData" in response.TicketData) {
                                $('#boughtTicketId').html(" ID " + response.TicketData.LeagueTicketData[0].TicketID);
                            }
                        }
                         slip.emptySlip();
                         module.exports.getTickets();
                         var updateCreditEvent = new CustomEvent("get_credit");
                         window.dispatchEvent(updateCreditEvent);
                    }
                  
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if(debug){
                        alert(errorThrown)
                    }
                }
            });
        }); 
    } else {
        $.ajax({
            url: window['API_URL'] + '/vfootball-league/ticket/buy',
            type: "post",
            data: ticketJson , 
            success: function (response) {
                if(response.Status == 0){
                    $('#modalErrorMessage').text(translation['error_purchasing_ticket']);
                    $('#buyTicketError').modal('show');
                    return false;
                } else {
                    $('#modalErrorMessage').text(translation['purchased_a_ticket']);
                    $('#buyTicketError').modal('show');
                    if ("TicketData" in response) {
                        if ("LeagueTicketData" in response.TicketData) {
                            $('#boughtTicketId').html(" ID " + response.TicketData.LeagueTicketData[0].TicketID);
                        }
                    }
                     slip.emptySlip();
                     module.exports.getTickets();
                     var updateCreditEvent = new CustomEvent("get_credit");
                     window.dispatchEvent(updateCreditEvent);
                }
              
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if(debug){
                    alert(errorThrown)
                }
            }
        });
    }
}

function ticketToString() {
    var ticket = '|';
     $.each( slip.getSlip(), function( key, value ) {
        let matchId = key.slice(0, (key.length - value.betCode.length) -1);
        ticket += matchId+'-'+value.betCode+'|';
    });

     return ticket;
}

function checkTicket(data, result) {
    $.each( data, function( key, value ) {
        var totalWin = 0;
        var systemFrom = value[0].SystemFrom;
        var systemTo = value[0].SystemTo;
        console.log('TicketMatches: '+value.length);
        for (var i = value.length - 1; i >= 0; i--) {
            if(checkMatch(value[i].OddCode, result[value[i].ID_MatchSchedule])){
                totalWin++;
                $('*[data-matchId="'+value[i].ID_MatchSchedule+'"][data-oddcode="'+value[i].OddCode+'"]').css({'color': '#36ba14'});
            }else {
                $('*[data-matchId="'+value[i].ID_MatchSchedule+'"][data-oddcode="'+value[i].OddCode+'"]').css({'color': 'red'});
            }
        }
        console.log(systemFrom);
        if(totalWin >= parseInt(systemFrom)){
            $('.ticket-status', '#ticket_'+value[0].TicketID).css({'color': '#36ba14'}).text('WON');
        } else {
            $('.ticket-status', '#ticket_'+value[0].TicketID).css({'color': 'red'}).text('LOST');
        }
     })
}

function ticketToString() {
    var ticket = '|';
     $.each( slip.getSlip(), function( key, value ) {
        let matchId = key.slice(0, (key.length - value.betCode.length) -1);
        ticket += matchId+'-'+value.betCode+'|';
    });

     return ticket;
}

function ticketHtml(ticketId, ticketInfo) {
    var html = '<div class="ticket-holder ticket-holder-virtualf" id="ticket_'+ticketId+'">'+
                    '<div class="ticket-bar ticket-bar clearfix">'+
                        '<div class="ticket-bar-left">Ticket ID : '+ticketId+'</div>'+
                        '<div class="ticket-bar-right ticket-status">OPEN</div>'+
                    '</div>'+
                    '<div class="ticket-body-virtualf">';
                    $.each( ticketInfo, function( key, value ) {
                    html += '<div class="ticket-virtual-bar" data-matchId="'+value.ID_MatchSchedule+'" data-oddCode="'+value.OddCode+'">'+
                            '<div class="virtualf-team-holder">'+
                                '<div class="team-home">'+value.home+'</div>-<div class="team-away">'+value.away+'</div>'+
                            '</div>'+
                            '<div class="virtualf-result-holder">'+value.oddName+'</div>'+
                            '<div class="virtualf-odds-holder">'+parseFloat(value.OddValue).toFixed(2)+'</div>'+
                        '</div>';
                        });
                    html += '<div class="virtualf-tickets-stats-holder">'+
                            '<div class="virtualf-tickets-stats">'+
                                '<div>Combinations: <span>1</span></div>'+
                                '<div>System: <span>'+ticketInfo[0].SystemFrom+'/'+ticketInfo[0].SystemTo+'</span></div>'+
                                '<div>Total Stake: <span>'+ticketInfo[0].TicketAmount+'</span></div>'+
                            '</div>'+
                            '<div class="virtualf-potential-max-win">'+
                                '<div class="vpmw-title">Potential Maximal Win</div>'+
                                '<div class="vpmw-amount vpmw-amount-won">'+(ticketInfo[0].EvMaxWin).toFixed(2)+' ' + (CookieHelper.get('currency') || window['currency']) + ' </div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                '</div>';
                return html;
}

function checkMatch(oddCode, result) {
    var totalGoals = result.homeGoals + result.awayGoals;
    var gg = result.homeGoals > 0 && result.awayGoals > 0 ? true : false;
    var ggFirst = result.homeHtGoals > 0 && result.awayHtGoals > 0 ? true : false;
    switch(oddCode) {
        case 1: // 1
            if(result.homeGoals > result.awayGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 2: // 2
            if(result.homeGoals < result.awayGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 0: // X
            if(result.homeGoals == result.awayGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 112: //12
            if(result.homeGoals !== result.awayGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 102: //X2
            if(result.homeGoals <= result.awayGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 110: //1X
            if(result.homeGoals >= result.awayGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 211: //1-1
            if(result.homeGoals > result.awayGoals && result.homeHtGoals > result.awayHtGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 212: //1-2
            if(result.homeGoals < result.awayGoals && result.homeHtGoals > result.awayHtGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 210: //1-X
            if(result.homeGoals == result.awayGoals && result.homeHtGoals > result.awayHtGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 200: // X-X
            if(result.homeGoals == result.awayGoals && result.homeHtGoals == result.awayHtGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 202: // X-2
            if(result.homeGoals < result.awayGoals && result.homeHtGoals == result.awayHtGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 201: //X-1
            if(result.homeGoals > result.awayGoals && result.homeHtGoals == result.awayHtGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 221: //2-1
            if(result.homeGoals < result.awayGoals && result.homeHtGoals > result.awayHtGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 222: //2-2
            if(result.homeGoals < result.awayGoals && result.homeHtGoals < result.awayHtGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 220: //2-X
            if(result.homeGoals == result.awayGoals && result.homeHtGoals < result.awayHtGoals) {
                return true;
            } else {
                return false;
            }
            break;
        case 316: // +1.5
            if(result.homeGoals + result.awayGoals >= 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 314: // -1.5
            if(result.homeGoals + result.awayGoals < 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 324: //-2.5
            if(result.homeGoals + result.awayGoals < 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 326: // + 2.5
            if(result.homeGoals + result.awayGoals >= 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 336: // +3.5
            if(result.homeGoals + result.awayGoals >= 4) {
                return true;
            } else {
                return false;
            }
            break;
        case 334: // -3.5
            if(result.homeGoals + result.awayGoals < 4) {
                return true;
            } else {
                return false;
            }
            break;
        case 344: // -4.5
            if(result.homeGoals + result.awayGoals < 5) {
                return true;
            } else {
                return false;
            }
            break;
        case 346: // +4.5
            if(result.homeGoals + result.awayGoals >= 5) {
                return true;
            } else {
                return false;
            }
            break;
        case 442: // TG 2
            if(result.homeGoals + result.awayGoals == 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 440: // TG 0
             if(result.homeGoals + result.awayGoals == 0) {
                return true;
            } else {
                return false;
            }
            break;
        case 441: // TG 1
             if(result.homeGoals + result.awayGoals == 1) {
                return true;
            } else {
                return false;
            }
            break; 
        case 444: // TG 4
             if(result.homeGoals + result.awayGoals == 4) {
                return true;
            } else {
                return false;
            }
            break;
        case 443: // TG 3
             if(result.homeGoals + result.awayGoals == 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 445: // TG 5
             if(result.homeGoals + result.awayGoals == 5) {
                return true;
            } else {
                return false;
            }
            break; 
        case 446: // TG 6
             if(result.homeGoals + result.awayGoals == 6) {
                return true;
            } else {
                return false;
            }
            break; 
        case 500: // 1&2-3
            if(result.homeGoals > result.awayGoals && totalGoals == 2 || totalGoals == 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 502: // 1&3+
            if(result.homeGoals > result.awayGoals && totalGoals >= 3) {
                return true;
            } else {
                return false;
            }
            break; 
        case 501: // 2&2-3
            if(result.homeGoals < result.awayGoals && totalGoals == 2 || totalGoals == 3) {
                return true;
            } else {
                return false;
            }
            break; 
        case 504: // 1&4+
            if(result.homeGoals > result.awayGoals && totalGoals >= 4) {
                return true;
            } else {
                return false;
            }
            break; 
        case 505: // 2&4+
            if(result.homeGoals < result.awayGoals && totalGoals >= 4) {
                return true;
            } else {
                return false;
            }
            break;
        case 503: // 2&3+
            if(result.homeGoals < result.awayGoals && totalGoals >= 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 600: // 0:0
            if(result.homeGoals == 0 && result.awayGoals == 0) {
                return true;
            } else {
                return false;
            }
            break;
        case 611: // 1:1
            if(result.homeGoals == 1 && result.awayGoals == 1) {
                return true;
            } else {
                return false;
            }
            break; 
        case 610: // 1:0
            if(result.homeGoals == 1 && result.awayGoals == 0) {
                return true;
            } else {
                return false;
            }
            break;
        case 620: // 2:0
            if(result.homeGoals == 2 && result.awayGoals == 0) {
                return true;
            } else {
                return false;
            }
            break;
        case 621: // 2:1
            if(result.homeGoals == 2 && result.awayGoals == 1) {
                return true;
            } else {
                return false;
            }
            break;
        case 601: // 0:1
            if(result.homeGoals == 0 && result.awayGoals == 1) {
                return true;
            } else {
                return false;
            }
            break; 
        case 622: // 2:2
            if(result.homeGoals == 2 && result.awayGoals == 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 602: // 0:2
             if(result.homeGoals == 0 && result.awayGoals == 2) {
                return true;
            } else {
                return false;
            }
            break; 
        case 612: // 1:2
             if(result.homeGoals == 1 && result.awayGoals == 2) {
                return true;
            } else {
                return false;
            }
            break; 
        case 631: // 3:1
             if(result.homeGoals == 3 && result.awayGoals == 1) {
                return true;
            } else {
                return false;
            }
            break; 
        case 632: // 3:2
             if(result.homeGoals == 3 && result.awayGoals == 2) {
                return true;
            } else {
                return false;
            }
            break; 
        case 630: // 3:0
             if(result.homeGoals == 3 && result.awayGoals == 0) {
                return true;
            } else {
                return false;
            }
            break; 
        case 633: // 3:3
             if(result.homeGoals == 3 && result.awayGoals == 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 613: // 1:3
             if(result.homeGoals == 1 && result.awayGoals == 3) {
                return true;
            } else {
                return false;
            }
            break; 
        case 623: // 2:3
             if(result.homeGoals == 2 && result.awayGoals == 3) {
                return true;
            } else {
                return false;
            }
            break; 
        case 603: // 0:3
             if(result.homeGoals == 0 && result.awayGoals == 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 666: // Other
            if(result.homeGoals > 3  || result.awayGoals > 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 11: // GG
            if(gg) {
                return true;
            } else {
                return false;
            }
            break;
        case 10: // NG
            if(!gg) {
                return true;
            } else {
                return false;
            }
            break;
        case 21: // Odd
            if(totalGoals & 1) {
                return true;
            } else {
                return false;
            }
            break;
        case 22: // Even
            if(totalGoals & 1) {
                return false;
            } else {
                return true;
            }
            break;
        case 31: // Home Odd
            if(result.homeGoals & 1) {
                return true;
            } else {
                return false;
            }
            break;
        case 32: // Home Even
            if(result.homeGoals & 1) {
                return false;
            } else {
                return true;
            }
            break;
        case 41: // Away Odd
            if(result.awayGoals & 1) {
                return true;
            } else {
                return false;
            }
            break;
        case 42: // Away Even
            if(result.awayGoals & 1) {
                return false;
            } else {
                return true;
            }
            break;
        case 410: // Home Goals 0
            if(result.homeGoals == 0) {
                return true;
            } else {
                return false;
            }
            break;
        case 411: // Home Goals 1
            if(result.homeGoals == 1) {
                return true;
            } else {
                return false;
            }
            break; 
        case 412: // Home Goals 2
            if(result.homeGoals == 2) {
                return true;
            } else {
                return false;
            }
            break; 
        case 413: // Home Goals 3
            if(result.homeGoals == 3) {
                return true;
            } else {
                return false;
            }
            break; 
        case 414: // Home Goals 4
            if(result.homeGoals == 4) {
                return true;
            } else {
                return false;
            }
            break; 
        case 415: // Home Goals 5
            if(result.homeGoals == 5) {
                return true;
            } else {
                return false;
            }
            break; 
        case 416: // Home Goals 6
            if(result.homeGoals == 6) {
                return true;
            } else {
                return false;
            }
            break;
        case 420: // Away Goals 0
            if(result.homeGoals == 0) {
                return true;
            } else {
                return false;
            }
            break;
        case 421: // Away Goals 1
            if(result.awayGoals == 1) {
                return true;
            } else {
                return false;
            }
            break; 
        case 422: // Away Goals 2
            if(result.awayGoals == 2) {
                return true;
            } else {
                return false;
            }
            break; 
        case 423: // Away Goals 3
            if(result.awayGoals == 3) {
                return true;
            } else {
                return false;
            }
            break; 
        case 424: // Away Goals 4
            if(result.awayGoals == 4) {
                return true;
            } else {
                return false;
            }
            break; 
        case 425: // Away Goals 5
            if(result.awayGoals == 5) {
                return true;
            } else {
                return false;
            }
            break; 
        case 426: // Away Goals 6
            if(result.awayGoals == 6) {
                return true;
            } else {
                return false;
            }
            break;
        case 704: // Home Goals < 0.5
            if(result.homeGoals == 0) {
                return true;
            } else {
                return false;
            }
            break;
        case 706: // Home Goals > 0.5
            if(result.homeGoals >= 1) {
                return true;
            } else {
                return false;
            }
            break;
        case 714: // Home Goals < 1.5
            if(result.homeGoals < 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 716: // Home Goals > 1.5
            if(result.homeGoals >= 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 724: // Home Goals < 2.5
            if(result.homeGoals < 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 726: // Home Goals > 2.5
            if(result.homeGoals >= 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 734: // Home Goals < 3.5
            if(result.homeGoals < 4) {
                return true;
            } else {
                return false;
            }
            break;
        case 736: // Home Goals > 3.5
            if(result.homeGoals >= 4) {
                return true;
            } else {
                return false;
            }
            break;
        case 804: // Away Goals < 0.5
            if(result.awayGoals == 0) {
                return true;
            } else {
                return false;
            }
            break;
        case 806: // Away Goals > 0.5
            if(result.awayGoals >= 1) {
                return true;
            } else {
                return false;
            }
            break;
        case 814: // Away Goals < 1.5
            if(result.awayGoals < 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 816: // Away Goals > 1.5
            if(result.awayGoals >= 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 824: // Away Goals < 2.5
            if(result.awayGoals < 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 826: // Away Goals > 2.5
            if(result.awayGoals >= 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 834: // Away Goals < 3.5
            if(result.awayGoals < 4) {
                return true;
            } else {
                return false;
            }
            break;
        case 836: // Away Goals > 3.5
            if(result.awayGoals >= 4) {
                return true;
            } else {
                return false;
            }
            break;
        case 114: // 1&-1.5
            if(result.homeGoals > result.awayGoals && totalGoals < 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 14: // X&-1.5
            if(result.homeGoals == result.awayGoals && totalGoals < 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 214: // 2&-1.5
            if(result.homeGoals < result.awayGoals && totalGoals < 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 116: // 1&-1.5
            if(result.homeGoals > result.awayGoals && totalGoals >= 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 16: // X&-1.5
            if(result.homeGoals == result.awayGoals && totalGoals >= 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 216: // 2&-1.5
            if(result.homeGoals < result.awayGoals && totalGoals >= 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 124: // 1&-2.5
            if(result.homeGoals > result.awayGoals && totalGoals < 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 24: // X&-2.5
            if(result.homeGoals == result.awayGoals && totalGoals < 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 224: // 2&-2.5
            if(result.homeGoals < result.awayGoals && totalGoals < 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 126: // 1&-1.5
            if(result.homeGoals > result.awayGoals && totalGoals >= 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 26: // X&-1.5
            if(result.homeGoals == result.awayGoals && totalGoals >= 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 226: // 2&-1.5
            if(result.homeGoals < result.awayGoals && totalGoals >= 2) {
                return true;
            } else {
                return false;
            }
            break;
        case 251: // gg&-2.5
            if(gg && totalGoals < 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 252: // gg&+2.5
            if(gg && totalGoals >= 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 261: // gg&-2.5
            if(!gg && totalGoals < 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 262: // gg&+2.5
            if(!gg && totalGoals >= 3) {
                return true;
            } else {
                return false;
            }
            break;
        case 191: //1x&nh
            if(result.homeGoals >= result.awayGoals &&  !gg) {
                return true;
            } else {
                return false;
            }
            break;
        case 192: //12&ng
            if(result.homeGoals != result.awayGoals && !gg) {
                return true;
            } else {
                return false;
            }
            break;
        case 190: //x2&ng
            if(result.homeGoals <= result.awayGoals && !gg) {
                return true;
            } else {
                return false;
            }
            break;
        case 181: //1x&gg
            if(result.homeGoals >= result.awayGoals &&  gg) {
                return true;
            } else {
                return false;
            }
            break;
        case 182: //12&gg
            if(result.homeGoals != result.awayGoals && gg) {
                return true;
            } else {
                return false;
            }
            break;
        case 180: //x2&gg
            if(result.homeGoals <= result.awayGoals && gg) {
                return true;
            } else {
                return false;
            }
            break;
         case 301: // I 1
            if(result.homeHtGoals > result.awayHtGoals ) {
                return true;
            } else {
                return false;
            }
            break;
        case 300: // I X
            if(result.homeHtGoals == result.awayHtGoals ) {
                return true;
            } else {
                return false;
            }
            break;
        case 302: // I 2
            if(result.homeHtGoals < result.awayHtGoals ) {
                return true;
            } else {
                return false;
            }
            break;
        case 810: // I 1X
            if(result.homeHtGoals >= result.awayHtGoals ) {
                return true;
            } else {
                return false;
            }
            break;
        case 812: // I 12
            if(result.homeHtGoals != result.awayHtGoals ) {
                return true;
            } else {
                return false;
            }
            break;
        case 802: // I X2
            if(result.homeHtGoals <= result.awayHtGoals ) {
                return true;
            } else {
                return false;
            }
            break;
        case 511: // I gg
            if(ggFirst) {
                return true;
            } else {
                return false;
            }
            break;
        case 511: // I ng
            if(!ggFirst) {
                return true;
            } else {
                return false;
            }
            break;

    }
}



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/ticket/ticket.js
// module id = 322
// module chunks = 4